import * as React from 'react';
import {AccountAvatar} from 'src/AccountAvatar';
import IconBadge from 'src/IconBadge';
import type {AccountListItemFragment} from '@transactions/graphql';

type Props = {
  account: AccountListItemFragment;
};

export const AccountInlineDisplay = (props: Props) => (
  <IconBadge icon={<AccountAvatar account={props.account} />}>
    <span className="block truncate">{props.account.name}</span>
  </IconBadge>
);
